import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  keywordLabel,
  KeywordType,
  SiService,
  siteIntelligenceServiceLabel,
} from '../../../pages/siteIntelligence/mappings';
import { getKeywordTypeColor } from './KeywordTypeBadge';

interface Props {
  types: Array<KeywordType | SiService>;
  limit?: number;
}

export default function KeywordTypeInitialsGroup({ types, limit }: Props) {
  const limitedTypes = limit ? types.slice(0, limit) : types;
  const remainingTypesLabel = limit
    ? types
        .slice(limit)
        .map((type) => siteIntelligenceServiceLabel[type] ?? keywordLabel[type] ?? type)
        .join(', ')
    : '';

  return (
    <div className='symbol-group symbol-hover flex-nowrap'>
      {limitedTypes.map((type: KeywordType | SiService, idx) => {
        const colors = getKeywordTypeColor(type);
        const labelWhole = siteIntelligenceServiceLabel[type] ?? keywordLabel[type] ?? type;
        const labelInitials = type
          .replace(/[^a-zA-Z]/g, '')
          .slice(0, 2)
          .toUpperCase();
        return (
          <OverlayTrigger key={idx} placement='bottom' overlay={<Tooltip>{labelWhole}</Tooltip>}>
            <div className='symbol symbol-circle symbol-25px border-light'>
              <div
                className={`symbol-label fs-8 fw-bold text-${colors.fontColor}`}
                style={{
                  backgroundColor: colors.color,
                }}
              >
                {labelInitials}
              </div>
            </div>
          </OverlayTrigger>
        );
      })}
      {limit && types.length > limit && (
        <OverlayTrigger placement='bottom' overlay={<Tooltip>{remainingTypesLabel}</Tooltip>}>
          <div className='symbol symbol-circle symbol-25px border-light'>
            <div className={`symbol-label fs-8 fw-bold`}>+{types.length - limit}</div>
          </div>
        </OverlayTrigger>
      )}
    </div>
  );
}
